var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15633 2.83887C3.98505 2.00976 4.969 1.35206 6.05198 0.903326C7.13495 0.454595 8.29572 0.223633 9.46797 0.223633C10.6402 0.223633 11.801 0.454595 12.884 0.903326C13.9669 1.35206 14.9509 2.00976 15.7796 2.83887C16.7295 3.78873 18.2695 3.78873 19.2194 2.83887C20.8933 1.16492 23.1637 0.2245 25.531 0.2245C27.8983 0.224501 30.1687 1.16492 31.8427 2.83887C33.5166 4.51282 34.457 6.78319 34.457 9.15051C34.457 11.5178 33.5166 13.7882 31.8427 15.4622L30.1228 17.182L20.3279 26.9769C18.7658 28.539 16.2332 28.539 14.6711 26.9769L4.87621 17.182L3.15633 15.4622C2.32723 14.6334 1.66953 13.6495 1.22079 12.5665C0.772064 11.4835 0.5411 10.3228 0.5411 9.15051C0.5411 7.97825 0.772064 6.81748 1.22079 5.73451C1.66953 4.65154 2.32723 3.66759 3.15633 2.83887Z",
    fill: "#FF6430"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.28d4109961a4f2c471b29986cf87c241.svg";
export { ForwardRef as ReactComponent };